<template>
  <v-app>
    <Navigation v-if="viewLayout"></Navigation>
    <router-view v-else />
  </v-app>
</template>

<script>
import Navigation from "@/components/Navigation.vue";
export default {
  name: "App",
  components: { Navigation },
  computed: {
    viewLayout() {
      const n = this.$route.name;
      return n !== "Login" && n !== "Setup" && n !== "Welcome";
    },
  },
};
</script>

<style>
html { overflow: scroll; overflow-x: hidden; }
::-webkit-scrollbar { width: 3px; background: white; }
::-webkit-scrollbar-thumb { background: #e4e4e4; }
body { font-family: "Inter", sans-serif; }
.v-application { background-color: #f6f9fc !important; }
</style>